(function () {
  function initDhlServicePoint(root) {
    if (!root || root.getAttribute('data-dhl-sp-bound') === 'true') return;
    root.setAttribute('data-dhl-sp-bound', 'true');

    var api = (root.getAttribute('data-api') || '').replace(/\/$/, '');
    var country = (root.getAttribute('data-country') || 'SE').trim().toUpperCase();
    var postal = root.querySelector('[data-dhl-sp-postal]');
    var btn = root.querySelector('[data-dhl-sp-search]');
    var statusEl = root.querySelector('[data-dhl-sp-status]');
    var list = root.querySelector('[data-dhl-sp-list]');
    var selectedEl = root.querySelector('[data-dhl-sp-selected]');

    if (!postal || !btn || !api) return;

    var i18n = {};
    try {
      i18n = JSON.parse(root.getAttribute('data-i18n') || '{}');
    } catch (e) {
      i18n = {};
    }

    function getLeveranssattInput() {
      var cartPage = root.closest('[data-cart-page]');
      if (cartPage) {
        return cartPage.querySelector('[data-cart-leveranssatt-global]');
      }
      return root.querySelector('[data-dhl-leveranssatt]');
    }

    function setHidden(id, name, pc) {
      var h1 = root.querySelector('[data-dhl-ombud-id]') || root.querySelector('input[name="attributes[DHL-ombud]"]');
      var h2 = root.querySelector('input[name="attributes[DHL-ombud-namn]"]');
      var h3 = root.querySelector('input[name="attributes[DHL-postnr]"]');
      var hLand = root.querySelector('[data-dhl-land]') || root.querySelector('input[name="attributes[DHL-land]"]');
      var h4 = getLeveranssattInput();
      if (h1) h1.value = id || '';
      if (h2) h2.value = name || '';
      if (h3) h3.value = pc || '';
      if (hLand) hLand.value = id ? country : '';
      if (h4) h4.value = id ? 'DHL Service point(ombud)' : '';
    }

    function buildPickButton(sp) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'tambur-dhl-sp__pick';
      var name = document.createElement('span');
      name.className = 'tambur-dhl-sp__pick-name';
      name.textContent = sp.name || i18n.defaultName || 'Ombud';
      var meta = document.createElement('span');
      meta.className = 'tambur-dhl-sp__pick-meta';
      var addr = [sp.street, sp.city].filter(Boolean).join(', ');
      var dist =
        sp.distance != null ? sp.distance + ' ' + (sp.distanceUnit || 'km') : '';
      meta.textContent = [addr, dist].filter(Boolean).join(' · ');
      b.appendChild(name);
      b.appendChild(meta);
      return b;
    }

    function search() {
      var pc = (postal.value || '').replace(/\s/g, '');
      if (pc.length < 3) {
        if (statusEl) statusEl.textContent = i18n.invalidPostal || 'Ange ett giltigt postnummer.';
        return;
      }
      if (statusEl) statusEl.textContent = i18n.searching || 'Söker ombud…';
      if (list) list.innerHTML = '';

      fetch(api + '/api/public/servicepoints?postal=' + encodeURIComponent(pc) + '&country=' + encodeURIComponent(country))
        .then(function (r) { return r.json(); })
        .then(function (d) {
          var sps = (d && d.servicePoints) || [];
          if (!sps.length) {
            if (statusEl) statusEl.textContent = i18n.noneFound || 'Inga ombud hittades — prova ett annat postnummer.';
            return;
          }
          if (statusEl) statusEl.textContent = i18n.choose || 'Välj ett ombud:';
          if (!list) return;
          sps.forEach(function (sp) {
            var li = document.createElement('li');
            li.className = 'tambur-dhl-sp__item';
            var b = buildPickButton(sp);
            b.addEventListener('click', function () { choose(sp, pc); });
            li.appendChild(b);
            list.appendChild(li);
          });
        })
        .catch(function () {
          if (statusEl) statusEl.textContent = i18n.fetchError || 'Kunde inte hämta ombud just nu. Försök igen.';
        });
    }

    function choose(sp, pc) {
      var label =
        sp.name + ', ' + (sp.street || '') + ', ' + (sp.postalCode || '') + ' ' + (sp.city || '');
      if (statusEl) statusEl.textContent = i18n.saving || 'Sparar val…';
      if (list) list.innerHTML = '';

      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          attributes: {
            'DHL-ombud': sp.id,
            'DHL-ombud-namn': label,
            'DHL-postnr': pc,
            'DHL-land': country,
            'Leveranssätt': 'DHL Service point(ombud)'
          }
        })
      })
        .then(function (r) { return r.json(); })
        .then(function () {
          if (selectedEl) {
            var prefix = i18n.selectedPrefix || 'Valt ombud: __NAME__';
            selectedEl.innerHTML = prefix.replace('__NAME__', '<strong>' + label + '</strong>');
            selectedEl.hidden = false;
          }
          if (statusEl) statusEl.textContent = '';
          setHidden(sp.id, label, pc);
          root.classList.add('is-selected');
        })
        .catch(function () {
          if (statusEl) statusEl.textContent = i18n.saveError || 'Kunde inte spara valet. Försök igen.';
        });
    }

    btn.addEventListener('click', search);
    postal.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') {
        e.preventDefault();
        search();
      }
    });
  }

  function initAll(scope) {
    var root = scope && scope.querySelector ? scope : document;
    root.querySelectorAll('.tambur-dhl-sp').forEach(initDhlServicePoint);
  }

  initAll(document);
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
